<template>
  <div ref="OperationalDashboardpdf" id="OperationalDashboardpdf">
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <div class="gutr mt-3">
      <div class="row">
        <div class="col-xl-12 col-sm-12 grid-margin stretch-card">
          <div>
            <b-navbar toggleable="lg" type="dark" variant="info">
              <b-navbar-brand style="padding: 0.475rem 1rem">
                <h3>Operational Dashboard</h3>
              </b-navbar-brand>

              <b-navbar-nav class="ml-auto">
                <b-nav-form>
                  <b-button-group size="sm" class="m2-1 text-right">
                    <b-button
                      :variant="
                        Filter.CommonFilter ||
                        Filter.ass_date ||
                        Filter.sob_date ||
                        Filter.branchfilter ||
                        Filter.shippingLineFilter ||
                        Filter.fclLclFilter ||
                        Filter.transportTypeFilter ||
                        Filter.clientIdFilter ||
                        Filter.PORfilter ||
                        Filter.PODfilter ||
                        Filter.POLfilter ||
                        Filter.FPODfilter ||
                        Filter.containerTypeFilter ||
                        Filter.assignmentNoFilter ||
                        Filter.QDFilter ||
                        Filter.QFlag ||
                        Filter.DFlag ||
                        Filter.dateRange.startDate ||
                        Filter.dateRange.endDate ||
                        Filter.dateRange.PICKfilter ||
                        Filter.dateRange.HANDfilter
                          ? 'outline-danger'
                          : 'outline-primary'
                      "
                      :class="'ml-4' + visible ? null : 'collapsed'"
                      :aria-expanded="visible ? 'true' : 'false'"
                      aria-controls="collapse-4"
                      @click="visible = !visible"
                      >{{
                        Filter.CommonFilter ||
                        Filter.ass_date ||
                        Filter.sob_date ||
                        Filter.branchfilter ||
                        Filter.shippingLineFilter ||
                        Filter.fclLclFilter ||
                        Filter.transportTypeFilter ||
                        Filter.clientIdFilter ||
                        Filter.PORfilter ||
                        Filter.PODfilter ||
                        Filter.POLfilter ||
                        Filter.FPODfilter ||
                        Filter.containerTypeFilter ||
                        Filter.assignmentNoFilter ||
                        Filter.QDFilter ||
                        Filter.QFlag ||
                        Filter.DFlag ||
                        Filter.dateRange.startDate ||
                        Filter.dateRange.endDate ||
                        Filter.dateRange.PICKfilter ||
                        Filter.dateRange.HANDfilter
                          ? "Filter ON"
                          : "Filter OFF"
                      }}</b-button
                    >

                    <b-button
                      size="sm"
                      class="ml-1"
                      :disabled="ExcelBtnName != 'Export' ? true : false"
                      @click="getReportsAnalysis('Lead_Master_List', 'Export')"
                      variant="outline-info"
                    >
                      {{ ExcelBtnName }}
                      <b-spinner
                        v-if="ExcelBtnName != 'Export'"
                        small
                        label="Small Spinner"
                      ></b-spinner
                    ></b-button>
                    <b-button class="ml-2" variant="outline-info" @click="getPDF">
                      <i class="fa fa-cloud-download" aria-hidden="true"></i>
                    </b-button>

                    <b-button class="mr-2" variant="outline-secondary" @click="goBack"
                      >Back</b-button
                    >
                  </b-button-group>
                </b-nav-form>
              </b-navbar-nav>
            </b-navbar>

            <div v-if="visible">
              <b-card>
                <b-collapse v-model="visible" id="collapse-2">
                  <b-row>
                    <b-col md="3">
                      <label>Type</label>
                      <model-list-select
                        :list="CustomDateList"
                        v-model="Filter.QDFilter"
                        option-value="DVal"
                        option-text="DText"
                        placeholder="Select"
                        :isDisabled="Filter.QFlag"
                        @input="getCurrentLastDate"
                      ></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>Date</label>
                      <date-range-picker
                        :always-show-calendars="showCal"
                        v-model="Filter.dateRange"
                        :startDate="startDate"
                        :endDate="endDate"
                        :locale-data="locale"
                        :disabled="Filter.DFlag ? true : false"
                        @update="getOPTData"
                      ></date-range-picker>
                    </b-col>

                    <b-col md="3"
                      ><label>Assignment Date</label
                      ><b-form-input
                        type="date"
                        id="ass_date-datepicker"
                        v-model="Filter.ass_date"
                        placeholder="YYYY-MM-DD"
                        autocomplete="off"
                    /></b-col>
                    <b-col md="3">
                      <label>SOB Date</label>
                      <b-form-input
                        type="date"
                        :formatter="capitalizeAll"
                        placeholder="Select SOB Date"
                        id="newClientName"
                        name="newClientName"
                        autocomplete="off"
                        v-model="Filter.sob_date"
                      ></b-form-input>
                    </b-col>

                    <b-col md="3">
                      <label>Branch</label>
                      <model-list-select
                        :list="$store.getters['common/getAllBranchList']"
                        id="branchfilter"
                        v-model="Filter.branchfilter"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="All"
                        @input="getOPTData"
                        :isDisabled="
                          $sessionsStorage.get('designation') != 'Admin' ? true : false
                        "
                      ></model-list-select>
                    </b-col>

                    <b-col md="3">
                      <label>Client</label>
                      <model-list-select
                        :list="$store.getters['common/getAllClientList']"
                        id="clientfilter"
                        v-model="Filter.clientfilter"
                        option-value="clientId"
                        option-text="clientName"
                        placeholder="Select Client Name"
                        @input="getOPTData"
                      ></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>Shipping Line</label>
                      <model-list-select
                        :list="$store.getters['common/getAllShippingLineList']"
                        v-model="Filter.shippingLineFilter"
                        option-value="shippingId"
                        option-text="shippingLine"
                        placeholder="Select Shipping Line"
                        :isDisabled="
                          $sessionsStorage.get('designation') != 'Admin' ? true : false
                        "
                        @input="getOPTData"
                      ></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>Pickup</label>
                      <model-list-select
                        :list="$store.getters['commonDropdownMaster/getAllPickupList']"
                        v-model="Filter.PICKfilter"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select Pickup Location"
                      ></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>Handover</label>
                      <model-list-select
                        :list="$store.getters['commonDropdownMaster/getAllHandoverList']"
                        v-model="Filter.HANDfilter"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select Handover Location"
                      ></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>POR</label>
                      <model-list-select
                        @input="
                          getLocationList($event, 'All', 'finalAllPlaceDataPOR');
                          getOPTData();
                        "
                        @searchchange="
                          getLocationList($event, 'All', 'finalAllPlaceDataPOR')
                        "
                        :list="$store.getters['common/getAllPORList']"
                        v-model="Filter.PORfilter"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select POR"
                      ></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>POD</label>
                      <model-list-select
                        @input="
                          getLocationList($event, 'All', 'finalAllPlaceDataPOD');
                          getOPTData();
                        "
                        @searchchange="
                          getLocationList($event, 'All', 'finalAllPlaceDataPOD')
                        "
                        :list="$store.getters['common/getAllPODList']"
                        v-model="Filter.PODfilter"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select POD"
                      ></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>POL</label>
                      <model-list-select
                        @input="
                          getLocationList($event, 'All', 'finalAllPlaceDataPOD');
                          getOPTData();
                        "
                        @searchchange="
                          getLocationList($event, 'All', 'finalAllPlaceDataPOD')
                        "
                        :list="$store.getters['common/getAllPOLList']"
                        v-model="Filter.POLfilter"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select POL"
                      ></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>FPOD</label>
                      <model-list-select
                        @input="
                          getLocationList($event, 'All', 'finalAllPlaceDataPOD');
                          getOPTData();
                        "
                        @searchchange="
                          getLocationList($event, 'All', 'finalAllPlaceDataPOD')
                        "
                        :list="$store.getters['common/getAllLocationDetailsFinalList']"
                        v-model="Filter.FPODfilter"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select Final Port of Discharge"
                      ></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>Container Type</label>
                      <model-list-select
                        :list="$store.getters['common/getAllContainerTypeList']"
                        v-model="Filter.containerTypeFilter"
                        option-value="containerTypeId"
                        option-text="containerType"
                        placeholder="Select Container Type"
                        @input="getOPTData"
                      ></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>FCL/LCL</label>
                      <model-list-select
                        :list="flTypeList"
                        v-model="Filter.fclLclFilter"
                        option-value="flVal"
                        option-text="flText"
                        placeholder="Select FCL / LCL"
                        @input="getOPTData"
                      ></model-list-select
                    ></b-col>

                    <b-col md="3">
                      <label>Transport Type</label>
                      <model-list-select
                        :list="transportTypeName"
                        v-model="Filter.transportTypeFilter"
                        option-value="transportTypeVal"
                        option-text="transportTypeText"
                        placeholder="Select Export / Import"
                        @input="getOPTData"
                      ></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>Ass. No Filter</label>
                      <b-form-input
                        type="text"
                        :formatter="capitalizeAll"
                        placeholder="Search Ass. No Filter"
                        id="assignmentNoFilter"
                        name="assignmentNoFilter"
                        autocomplete="off"
                        v-model="Filter.assignmentNoFilter"
                        @input="getOPTData"
                      ></b-form-input>
                    </b-col>
                    <b-col md="6">
                      <label>Common Filter</label>
                      <b-form-input
                        type="text"
                        :formatter="capitalizeAll"
                        placeholder="Search Common Filter"
                        id="CommonFilter"
                        name="CommonFilter"
                        autocomplete="off"
                        v-model="Filter.CommonFilter"
                        @input="getOPTData"
                      ></b-form-input>
                    </b-col>
                    <b-col md="12" class="mt-2">
                      <b-button
                        size="sm"
                        style="margin-left: auto"
                        class="ml-1 pull-right"
                        @click="clearFilter"
                        variant="outline-danger"
                        >Reset</b-button
                      >
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </div>
            <div>
              <b-card>
                <b-row>
                  <b-col md="6"
                    ><h4 class="error">
                      Start Date : {{ DateLabel.StartDate }} / End Date :
                      {{ DateLabel.EndDate }}
                    </h4></b-col
                  >
                  <b-col md="6">
                    <b-button
                      :pressed="activeButtonBranch"
                      v-model="Filter.activeButtonFilter"
                      :variant="activeButtonBranch?'success':'danger'"
                      @click="BranchBtnFilter('Branch')"
                      >Branch {{activeButtonBranch?' Filter On':' Filter Off'}}</b-button
                    >
                    <b-button
                      :pressed="activeButtonClient"
                      v-model="Filter.activeButtonFilter"
                      :variant="activeButtonClient?'success':'danger'"
                      @click="BranchBtnFilter('Client')"
                      >Client {{activeButtonClient?' Filter On':' Filter Off'}}</b-button
                    ></b-col
                  >
                  <b-col md="6">
                    <h3>Export</h3>
                    <b-tabs v-model="FFExptabIndex" small card>
                      <b-tab title="Pending BL Status">
                        <b-card
                          @click="
                            getFFExpBLMainList.length > 0
                              ? goToTPTPage(
                                  'Export',
                                  'FF',
                                  getFFExpBLMainAllModuleIDString
                                )
                              : ''
                          "
                          class="mr-1 mb-1"
                          v-if="getFFExpBLMainList.length > 0"
                        >
                          <h3>
                            Pending BL Status :
                            <span class="text-danger"
                              >{{ getFFExpBLMainList.length }} Pending</span
                            >
                          </h3>
                        </b-card>
                      </b-tab>
                      <b-tab title="Pending SI Date">
                        <b-card
                          @click="
                            getFFExpSIMainList.length > 0
                              ? goToTPTPage(
                                  'Export',
                                  'FF',
                                  getFFExpSIMainAllModuleIDString
                                )
                              : ''
                          "
                          class="mr-1 mb-1"
                          v-if="getFFExpSIMainList.length > 0"
                        >
                          <h3>
                            SI Date :
                            <span class="text-danger"
                              >{{ getFFExpSIMainList.length }} Pending</span
                            >
                          </h3>
                        </b-card>
                      </b-tab>
                      <b-tab title="Pending VGM Date">
                        <b-card
                          @click="
                            getFFExpVGMMainList.length > 0
                              ? goToTPTPage(
                                  'Export',
                                  'FF',
                                  getFFExpVGMMainAllModuleIDString
                                )
                              : ''
                          "
                          class="mr-1 mb-1"
                          v-if="getFFExpVGMMainList.length > 0"
                        >
                          <h3>
                            VGM Date :
                            <span class="text-danger"
                              >{{ getFFExpVGMMainList.length }} Pending</span
                            >
                          </h3>
                        </b-card>
                      </b-tab>
                      <b-tab title="Pending Subscription"
                        ><b-card
                          @click="
                            getFFExpSubscriptionMainList.length > 0
                              ? goToTPTPage(
                                  'Export',
                                  'FF',
                                  getFFExpSubscriptionMainAllModuleIDString
                                )
                              : ''
                          "
                          class="mr-1 mb-1"
                          v-if="getFFExpSubscriptionMainList.length > 0"
                        >
                          <h3>
                            Subscription :
                            <span class="text-danger"
                              >{{ getFFExpSubscriptionMainList.length }} Pending</span
                            >
                          </h3>
                        </b-card></b-tab
                      >
                    </b-tabs>
                  </b-col>
                  <b-col md="6">
                    <h3>Import</h3>
                    <b-tabs v-model="FFImptabIndex" small card>
                      <b-tab title="Pending Subscription">I'm the first fading tab</b-tab>
                      <b-tab title="Pending SI Date">I'm the first fading tab</b-tab>
                      <b-tab title="Pending VGM Date">I'm the first fading tab</b-tab>
                      <b-tab title="Pending BL Status">I'm the first fading tab</b-tab>
                    </b-tabs>
                  </b-col>
                  <b-col md="6">
                    <!-- <h3>Export</h3> -->
                    <b-tabs v-model="CCExptabIndex" small card>
                      <b-tab title="Leo Date Pending"
                        ><b-card
                          @click="
                            getCCExpLDMainAllModuleIDList.length > 0
                              ? goToTPTPage(
                                  'Export',
                                  'CC',
                                  getCCExpLDMainAllModuleIDString
                                )
                              : ''
                          "
                          md="5"
                          class="mr-1 mb-1"
                          v-if="getCCExpLDMainAllModuleIDList.length > 0"
                        >
                          <h3>
                            Leo Date :
                            <span class="text-danger"
                              >{{ getCCExpLDMainAllModuleIDList.length }} Pending</span
                            >
                          </h3>
                        </b-card></b-tab
                      >
                    </b-tabs>
                  </b-col>
                  <b-col md="6">
                    <!-- <h3>Import</h3> -->
                    <b-tabs v-model="CCImptabIndex" small card>
                      <b-tab title="Pending Out Of Charge Date">
                        <b-card
                          @click="
                            getCCImpOOCDMainAllModuleIDList.length > 0
                              ? goToTPTPage(
                                  'Import',
                                  'CC',
                                  getCCImpOOCDMainAllModuleIDString
                                )
                              : ''
                          "
                          md="5"
                          class="mr-1 mb-1"
                          v-if="getCCImpOOCDMainAllModuleIDList.length > 0"
                        >
                          <h3>
                            Out Of Charge Date :
                            <span class="text-danger"
                              >{{ getCCImpOOCDMainAllModuleIDList.length }} Pending</span
                            >
                          </h3>
                        </b-card>
                      </b-tab>
                    </b-tabs>
                  </b-col>
                  <b-col md="6">
                    <!-- <h3>Export</h3> -->
                    <b-tabs v-model="TPTExptabIndex" small card>
                      <b-tab title="TPT Execution Pending">
                        <b-card
                          @click="
                            getTPTExpMainList.length > 0
                              ? goToTPTPage(
                                  'Export',
                                  'TPT',
                                  getTPTExpMainAllModuleIDString
                                )
                              : ''
                          "
                          md="5"
                          class="mr-1 mb-1"
                          v-if="getTPTExpMainList.length > 0"
                        >
                          <h3>
                            TPT Export :
                            <span class="text-danger"
                              >{{ getTPTExpMainList.length }} Pending</span
                            >
                          </h3>
                        </b-card></b-tab
                      >
                    </b-tabs>
                  </b-col>
                  <b-col md="6">
                    <!-- <h3>Import</h3> -->
                    <b-tabs v-model="TPTImptabIndex" small card>
                      <b-tab title="Container Execution Pending"
                        ><b-card
                          @click="
                            getTPTImpMainList.length > 0
                              ? goToTPTPage(
                                  'Import',
                                  'TPT',
                                  getTPTImpMainAllModuleIDString
                                )
                              : ''
                          "
                          md="5"
                          class="mr-1 mb-1"
                          v-if="getTPTImpMainList.length > 0"
                        >
                          <h3>
                            TPT Import :
                            <span class="text-danger"
                              >{{ getTPTImpMainList.length }} Pending</span
                            >
                          </h3>
                        </b-card></b-tab
                      >
                    </b-tabs>
                  </b-col>

                  <!-- <b-col
                    md="5"
                    @click="
                      getFFExpSubscriptionMainList.length > 0
                        ? goToTPTPage(
                            'Export',
                            'FF',
                            getFFExpSubscriptionMainAllModuleIDString
                          )
                        : ''
                    "
                    class="mr-1 mb-1"
                    v-if="getFFExpSubscriptionMainList.length > 0"
                  >
                    <b-card
                      @click="
                        getFFExpSubscriptionMainList.length > 0
                          ? goToTPTPage(
                              'Export',
                              'FF',
                              getFFExpSubscriptionMainAllModuleIDString
                            )
                          : ''
                      "
                      class="mr-1 mb-1"
                      v-if="getFFExpSubscriptionMainList.length > 0"
                    >
                      <h3>
                        Export Subscription :
                        <span class="text-danger"
                          >{{ getFFExpSubscriptionMainList.length }} Pending</span
                        >
                      </h3>
                    </b-card>
                  </b-col>
                  <b-col md="5" class="mr-1 mb-1" v-if="getFFExpMainList.length > 0">
                    <b-card>
                      <h3>
                        Export :
                        <span class="text-danger"
                          >{{ getFFExpMainList.length }} Pending</span
                        >
                      </h3>
                    </b-card>
                  </b-col>
                  <b-col md="5" class="mr-1 mb-1" v-if="getFFImpMainList.length > 0">
                    <b-card>
                      <h3>
                        Import :
                        <span class="text-danger"
                          >{{ getFFImpMainList.length }} Pending</span
                        >
                      </h3>
                    </b-card>
                  </b-col>
                  <b-col
                    @click="
                      getCCExpMainList.length > 0
                        ? goToTPTPage('Export', 'CC', getCCExpMainAllModuleIDString)
                        : ''
                    "
                    md="5"
                    class="mr-1 mb-1"
                    v-if="getCCExpMainList.length > 0"
                  >
                    <b-card @click="
                      getCCExpMainList.length > 0
                        ? goToTPTPage('Export', 'CC', getCCExpMainAllModuleIDString)
                        : ''
                    "
                    md="5"
                    class="mr-1 mb-1"
                    v-if="getCCExpMainList.length > 0">
                      <h3>
                        Export :
                        <span class="text-danger"
                          >{{ getCCExpMainList.length }} Pending</span
                        >
                      </h3>
                    </b-card>
                  </b-col>
                  <b-col
                    @click="
                      getCCImpMainList.length > 0
                        ? goToTPTPage('Import', 'CC', getCCImpMainAllModuleIDString)
                        : ''
                    "
                    md="5"
                    class="mr-1 mb-1"
                    v-if="getCCImpMainList.length > 0"
                  >
                    <b-card>
                      <h3>
                        Import :
                        <span class="text-danger"
                          >{{ getCCImpMainList.length }} Pending</span
                        >
                      </h3>
                    </b-card>
                  </b-col>
                  <b-col
                    @click="
                      getTPTExpMainList.length > 0
                        ? goToTPTPage('Export', 'TPT', getTPTExpMainAllModuleIDString)
                        : ''
                    "
                    md="5"
                    class="mr-1 mb-1"
                    v-if="getTPTExpMainList.length > 0"
                  >
                    <b-card  @click="
                      getTPTExpMainList.length > 0
                        ? goToTPTPage('Export', 'TPT', getTPTExpMainAllModuleIDString)
                        : ''
                    "
                    md="5"
                    class="mr-1 mb-1"
                    v-if="getTPTExpMainList.length > 0">
                      <h3>
                        Export :
                        <span class="text-danger"
                          >{{ getTPTExpMainList.length }} Pending</span
                        >
                      </h3>
                    </b-card>
                  </b-col>
                  <b-col
                    @click="
                      getTPTImpMainList.length > 0
                        ? goToTPTPage('Import', 'TPT', getTPTImpMainAllModuleIDString)
                        : ''
                    "
                    md="5"
                    class="mr-1 mb-1"
                    v-if="getTPTImpMainList.length > 0"
                  >
                    <b-card  @click="
                      getTPTImpMainList.length > 0
                        ? goToTPTPage('Import', 'TPT', getTPTImpMainAllModuleIDString)
                        : ''
                    "
                    md="5"
                    class="mr-1 mb-1"
                    v-if="getTPTImpMainList.length > 0">
                      <h3>
                        Import :
                        <span class="text-danger"
                          >{{ getTPTImpMainList.length }} Pending</span
                        >
                      </h3>
                    </b-card>
                  </b-col> -->
                </b-row>
              </b-card>
              <!-- Control buttons-->
              <div class="text-center">
                <b-button-group class="mt-2">
                  <b-button @click="tabIndex--">Previous</b-button>
                  <b-button @click="tabIndex++">Next</b-button>
                </b-button-group>

                <div class="text-muted">Current Tab: {{ tabIndex }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import CommonService from "../../services/CommonService.js";
import DashboardService from "../../services/DashboardService.js";

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/dashboard");
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllPickupDDList",
      JSON.stringify({
        itemCode: "AllPickupList",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllHandoverDDList",
      JSON.stringify({
        itemCode: "AllHandoverList",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllStuffingDDList",
      JSON.stringify({
        itemCode: "AllStuffingList",
      })
    );
    this.$store.dispatch(
      "common/setAllLocationDetailsFinalList",
      JSON.stringify({
        itemCode: "LocationDetailsFinalList",
      })
    );
    this.$store.dispatch(
      "common/setAllPORList",
      JSON.stringify({
        itemCode: "PORList",
      })
    );
    this.$store.dispatch(
      "common/setAllPODList",
      JSON.stringify({
        itemCode: "PODList",
         type:'Normal',
        Territory:'',
      })
    );
    this.$store.dispatch(
      "common/setAllPOLList",
      JSON.stringify({
        itemCode: "POLList",
      })
    );
    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({
        itemCode: "ContainerTypeList",
      })
    );
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.getOPTData();
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  // <router-link to @click.native="$router.push('/dashboard/dashboardReportsDetails/500')">500</router-link>
  data() {
    return {
      tabIndex: 1,
      FFExptabIndex: 1,
      FFImptabIndex: 1,
      CCExptabIndex: 1,
      CCImptabIndex: 1,
      TPTExptabIndex: 1,
      TPTImptabIndex: 1,
      flTypeList: [
        {
          flVal: "fcl",
          flText: "FCL",
        },
        {
          flVal: "lcl",
          flText: "LCL",
        },
      ],
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
      ],

      activeButtonBranch: true,
      activeButtonClient: false,
      Filter: {
        activeButtonFilter: "Branch",
        ass_date: "",
        sob_date: "",
        branchfilter: "",
        shippingLineFilter: "",
        fclLclFilter: "",
        transportTypeFilter: "",
        clientIdFilter: "",
        CommonFilter: "",
        PORfilter: "",
        PODfilter: "",
        POLfilter: "",
        FPODfilter: "",
        PICKfilter: "",
        HANDfilter: "",
        containerTypeFilter: "",
        assignmentNoFilter: "",
        QDFilter: "",
        QFlag: false,
        DFlag: false,
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      visible: false,
      ExcelBtnName: "Export",
      CustomDateList: [
        {
          DVal: "Q1",
          DText: "Q1",
        },
        {
          DVal: "Q2",
          DText: "Q2",
        },
        {
          DVal: "Q3",
          DText: "Q3",
        },
        {
          DVal: "Q4",
          DText: "Q4",
        },
        {
          DVal: "H1",
          DText: "H1",
        },
        {
          DVal: "H2",
          DText: "H2",
        },
      ],
      branchList: [],
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      tabIndex: 0,
      docURL: URL_BASE_DOC,
      getMainList: [],
      getTPTExpMainList: [],
      getTPTImpMainList: [],
      getTPTImpMainAllModuleIDString: "",
      getTPTExpMainAllModuleIDString: "",

      getFFExpSubscriptionMainList: [],
      getFFExpSubscriptionMainAllModuleIDList: [],
      getFFExpSubscriptionMainAllModuleIDString: "",

      getFFExpBLMainList: [],
      getFFExpBLMainAllModuleIDList: [],
      getFFExpBLMainAllModuleIDString: "",

      getFFExpSIMainList: [],
      getFFExpSIMainAllModuleIDList: [],
      getFFExpSIMainAllModuleIDString: "",

      getFFExpVGMMainList: [],
      getFFExpVGMMainAllModuleIDList: [],
      getFFExpVGMMainAllModuleIDString: "",

      getFFExpMainList: [],
      getFFImpMainList: [],
      getFFImpMainAllModuleIDString: "",
      getFFExpMainAllModuleIDString: "",

      getCCExpMainList: [],
      getCCImpMainList: [],
      getCCImpMainAllModuleIDString: "",
      getCCExpMainAllModuleIDString: "",

      getCCImpOOCDMainAllModuleIDList: [],
      getCCImpOOCDMainAllModuleIDList: [],
      getCCImpOOCDMainAllModuleIDString: "",
      getCCImpOOCDMainListCount: "",

      getCCExpLDMainAllModuleIDList: [],
      getCCExpLDMainAllModuleIDList: [],
      getCCExpLDMainAllModuleIDString: "",
      getCCExpLDMainListCount: "",

      isLoading: "",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      DateLabel: {
        StartDate: "",
        EndDate: "",
      },
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
  },

  computed: {},
  watch: {},
  methods: {
    BranchBtnFilter(type) {
      this.Filter.activeButtonFilter = type;
      if (type == "Branch") {
        this.activeButtonBranch = true;
        this.activeButtonClient = false;
      } else if (type == "Client") {
        this.activeButtonBranch = false;
        this.activeButtonClient = true;
      }
      this.getOPTData();
    },
    getReportsAnalysis(id, btnName) {
      let excelIdGivin = "";
      if (id == "Growth_Dashboard_Invoice_Excel") {
        excelIdGivin = "Growth_Dashboard_Invoice_Excel";
      }
      let payload = {
        excelId: excelIdGivin,
        dateRange: this.dateRange,
        Filter: this.Filter,
      };
      this.ExcelBtnName = "Downloading Please Wait......";
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      this.ExcelBtnName = btnName;
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
      }
    },
    getCurrentLastDate() {
      this.Filter.QFlag = false;
      this.Filter.DFlag = false;
      // alert(this.Filter.QDFilter)

      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = "";
      var firstDay_mm = "";
      var firstDay_yyyy = "";

      var lastDay_dd = "";
      var lastDay_mm = "";
      var lastDay_yyyy = "";
      if (this.Filter.QDFilter) {
        var Qdate = this.Filter.QDFilter;
        switch (Qdate) {
          case "Q1": {
            var firstDay = new Date(today.getFullYear(), 3);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);
            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();
            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "Q2": {
            var firstDay = new Date(today.getFullYear(), 6);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();
            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "Q3": {
            var firstDay = new Date(today.getFullYear(), 9);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();
            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "Q4": {
            var firstDay = new Date(today.getFullYear(), 12);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();

            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy : firstDay_yyyy - 1) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy : firstDay_yyyy - 1) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "H1": {
            var firstDay = new Date(today.getFullYear(), 3);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 6, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();

            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "H2": {
            var firstDay = new Date(today.getFullYear(), 9);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 6, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();

            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          default: {
            // alert(">41");
          }
        }
        this.Filter.QFlag = false;
        this.Filter.DFlag = true;
        // this.clearFilter();
      } else if (dateRange.startDate && !this.Filter.QDFilter) {
        this.Filter.QFlag = true;
        this.Filter.DFlag = false;
        // this.clearFilter();
      }

      // firstDay = (date('m') > 3) ? date('y') : date('y') - 1;
      // lastDay = (date('m') > 3) ? date('y') + 1 : date('y');

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      // alert(this.Filter.QDFilter)
      this.getOPTData();
    },
    goBack() {
      window.history.go(-1);
    },

    clearFilter() {
      this.Filter = {
        activeButtonFilter: "Branch",
        ass_date: "",
        sob_date: "",
        branchfilter: "",
        shippingLineFilter: "",
        fclLclFilter: "",
        transportTypeFilter: "",
        CommonFilter: "",
        clientIdFilter: "",
        PORfilter: "",
        PODfilter: "",
        POLfilter: "",
        FPODfilter: "",
        PICKfilter: "",
        HANDfilter: "",
        containerTypeFilter: "",
        assignmentNoFilter: "",
        QDFilter: "",
        QFlag: false,
        DFlag: false,
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.dateRange = {
        startDate: "",
        endDate: "",
      };
      this.getMainList = [];
      this.getTPTExpMainList = [];
      this.getTPTImpMainList = [];

      this.getFFExpSubscriptionMainList = [];
      this.getFFExpSubscriptionMainAllModuleIDList = [];
      this.getFFExpSubscriptionMainAllModuleIDString = "";

      this.getFFExpBLMainList = [];
      this.getFFExpBLMainAllModuleIDList = [];
      this.getFFExpBLMainAllModuleIDString = "";
      this.getFFExpBLMainListCount = "";

      this.getFFExpSIMainList = [];
      this.getFFExpSIMainAllModuleIDList = [];
      this.getFFExpSIMainAllModuleIDString = "";

      this.getFFExpVGMMainList = [];
      this.getFFExpVGMMainAllModuleIDList = [];
      this.getFFExpVGMMainAllModuleIDString = "";

      this.getFFExpMainList = [];
      this.getFFImpMainList = [];

      this.getCCExpMainList = [];
      this.getCCImpMainList = [];

      this.getTPTImpMainAllModuleIDString = "";
      this.getTPTExpMainAllModuleIDString = "";
      this.getFFImpMainAllModuleIDString = "";
      this.getFFExpMainAllModuleIDString = "";
      this.getCCImpMainAllModuleIDString = "";
      this.getCCExpMainAllModuleIDString = "";

      this.getCCImpOOCDMainAllModuleIDList = [];
      this.getCCImpOOCDMainAllModuleIDList = [];
      this.getCCImpOOCDMainAllModuleIDString = "";
      this.getCCImpOOCDMainListCount = "";

      this.getCCExpLDMainAllModuleIDList = [];
      this.getCCExpLDMainAllModuleIDList = [];
      this.getCCExpLDMainAllModuleIDString = "";
      this.getCCExpLDMainListCount = "";
    },
    goToTPTPage(type, Job, allModuleId) {
      console.log("type", type);
      console.log("allModuleId", allModuleId);
      this.$sessionsStorage.set("optTypeTransport", null);
      this.$sessionsStorage.set("optAllModuleIdTransport", null);
      this.$sessionsStorage.set("optTypeTransport", type);
      this.$sessionsStorage.set("optAllModuleIdTransport", allModuleId);

      if (Job == "TPT" && (type == "Export" || type == "Import")) {
        this.$router.push({
          path: "/listView/viewQuotation",
        });
      } else if (Job == "CC" && (type == "Export" || type == "Import")) {
        if (type == "Export") {
          this.$router.push({
            path: "/CCImport/CCExportDetail",
          });
        } else if (type == "Import") {
          this.$router.push({
            path: "/CCImport/CCImportDetails",
          });
        }
      } else if (Job == "FF" && (type == "Export" || type == "Import")) {
        if (type == "Export") {
          this.$router.push({
            path: "/freightForward/ViewffExportFcl",
          });
        } else if (type == "Import") {
          this.$router.push({
            path: "/seaImport/viewSeaImportDetails",
          });
        }
      }
    },

    getOPTData() {
      // this.Filter.transportTypeFilter =='Export'
      this.getOPTTPTExpData();
      this.getOPTTPTImpData();

      this.getOPTFFExpData();
      // this.getOPTFFImpData();

      this.getOPTCCExpData();
      this.getOPTCCImpData();
    },

    getOPTFFExpData() {
      this.isLoading = true;
      this.branchList = [];
      this.Filter.QFlag = false;
      this.Filter.DFlag = false;
      if (this.Filter.QDFilter) {
        this.Filter.QFlag = false;
        this.Filter.DFlag = true;
      } else if (this.dateRange.startDate && this.Filter.QDFilter == "") {
        this.Filter.QFlag = true;
        this.Filter.DFlag = false;
      }
      let payload = {
        itemCode: "getFFExpOperationalDashboardData",
        Filter: this.Filter,
      };

      DashboardService.getAllOptDashboard(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          this.isLoading = false;

          if (data.getFFExpMainList.length > 0) {
            this.getFFExpMainList = data.getFFExpMainList;
            this.getFFExpMainAllModuleIDString = data.getFFExpMainAllModuleIDString;
          } else {
            this.getFFExpMainList = [];
            this.getFFExpMainAllModuleIDString = "";
          }
          this.getOPTFFExpSubscriptionData();
        })
        .catch((error) => {
          console.log("Catch on getOPTFFExpData Error: ", error);
        });
    },
    getOPTFFExpSubscriptionData() {
      this.isLoading = true;
      this.branchList = [];
      this.Filter.QFlag = false;
      this.Filter.DFlag = false;
      if (this.Filter.QDFilter) {
        this.Filter.QFlag = false;
        this.Filter.DFlag = true;
      } else if (this.dateRange.startDate && this.Filter.QDFilter == "") {
        this.Filter.QFlag = true;
        this.Filter.DFlag = false;
      }
      let payload = {
        itemCode: "getFFExpSubscriptionOperationalDashboardData",
        Filter: this.Filter,
      };

      DashboardService.getAllOptDashboard(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          this.isLoading = false;
          this.DateLabel.StartDate = data.startDate;
          this.DateLabel.EndDate = data.endDate;
          if (data.getFFExpSubscriptionMainAllModuleIDString) {
            this.getFFExpSubscriptionMainList = data.getFFExpSubscriptionMainAllModuleIDString.split(
              ","
            );
            this.getFFExpSubscriptionMainAllModuleIDString =
              data.getFFExpSubscriptionMainAllModuleIDString;
          } else {
            this.getFFExpSubscriptionMainList = [];
            this.getFFExpSubscriptionMainAllModuleIDString = "";
          }

          if (data.getFFExpBLMainAllModuleIDString) {
            this.getFFExpBLMainList = data.getFFExpBLMainAllModuleIDString.split(",");
            this.getFFExpBLMainAllModuleIDString = data.getFFExpBLMainAllModuleIDString;
          } else {
            this.getFFExpBLMainList = [];
            this.getFFExpBLMainAllModuleIDString = "";
          }
          let getFFExpSIMainList = [];
          let getFFExpVGMMainList = [];
          if (typeof data.getFFExpSIMainList === "object") {
            //  getFFExpSIMainList = Object.entries(
            //   data.getFFExpSIMainList
            // ).map(([key, value]) => ({ key, value }));

            getFFExpSIMainList = Object.entries(data.getFFExpSIMainList).map(
              ([key, value]) => value
            );
          }
          if (typeof data.getFFExpVGMMainList === "object") {
            //  getFFExpVGMMainList = Object.entries(
            //   data.getFFExpVGMMainList
            // ).map(([key, value]) => ({ key, value }));

            getFFExpVGMMainList = Object.entries(data.getFFExpVGMMainList).map(
              ([key, value]) => value
            );
          }

          if (getFFExpSIMainList.length > 0) {
            this.getFFExpSIMainList = getFFExpSIMainList;
            this.getFFExpSIMainAllModuleIDString = getFFExpSIMainList.toString();
          } else {
            this.getFFExpSIMainList = [];
            this.getFFExpSIMainAllModuleIDString = "";
          }
          if (getFFExpVGMMainList.length > 0) {
            this.getFFExpVGMMainList = getFFExpVGMMainList;
            this.getFFExpVGMMainAllModuleIDString = getFFExpVGMMainList.toString();
          } else {
            this.getFFExpVGMMainList = [];
            this.getFFExpVGMMainAllModuleIDString = "";
          }
          console.log("getFFExpSIMainList=>", getFFExpSIMainList);
          console.log("getFFExpVGMMainList=>", getFFExpVGMMainList);
        })
        .catch((error) => {
          console.log("Catch on getOPTFFExpData Error: ", error);
        });
    },
    getOPTFFImpData() {
      this.isLoading = true;
      this.branchList = [];
      this.Filter.QFlag = false;
      this.Filter.DFlag = false;
      if (this.Filter.QDFilter) {
        this.Filter.QFlag = false;
        this.Filter.DFlag = true;
      } else if (this.dateRange.startDate && this.Filter.QDFilter == "") {
        this.Filter.QFlag = true;
        this.Filter.DFlag = false;
      }
      let payload = {
        itemCode: "getFFExpOperationalDashboardData",
        Filter: this.Filter,
      };

      DashboardService.getAllOptDashboard(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          this.isLoading = false;

          if (data.getFFImpMainList.length > 0) {
            this.getFFImpMainList = data.getFFImpMainList;
            this.getFFImpMainAllModuleIDString = data.getFFImpMainAllModuleIDString;
          } else {
            this.getFFImpMainList = [];
            this.getFFImpMainAllModuleIDString = "";
          }
        })
        .catch((error) => {
          console.log("Catch on getOPTFFImpData Error: ", error);
        });
    },

    getOPTCCExpData() {
      this.isLoading = true;
      this.branchList = [];
      this.Filter.QFlag = false;
      this.Filter.DFlag = false;
      if (this.Filter.QDFilter) {
        this.Filter.QFlag = false;
        this.Filter.DFlag = true;
      } else if (this.dateRange.startDate && this.Filter.QDFilter == "") {
        this.Filter.QFlag = true;
        this.Filter.DFlag = false;
      }
      let payload = {
        itemCode: "getCCExpOperationalDashboardData",
        Filter: this.Filter,
      };

      DashboardService.getAllOptDashboard(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          this.isLoading = false;

          this.getCCExpLDMainAllModuleIDList = [];
          this.getCCExpLDMainAllModuleIDList = [];
          this.getCCExpLDMainAllModuleIDString = "";
          this.getCCExpLDMainListCount = "";
          if (data.getCCExpMainLDList.length > 0) {
            this.getCCExpLDMainAllModuleIDList = data.getCCExpMainLDList;
            this.getCCExpLDMainAllModuleIDString =
              data.getCCExpMainLDListAllModuleIDString;
          } else {
            this.getCCExpLDMainAllModuleIDList = [];
            this.getCCExpLDMainAllModuleIDString = "";
          }
          // if (data.getCCExpMainList.length > 0) {
          //   this.getCCExpMainAllModuleIDString = data.getCCExpMainAllModuleIDString;
          //   this.getCCExpMainList = data.getCCExpMainList;
          // } else {
          //   this.getCCExpMainList = [];
          //   this.getCCExpMainAllModuleIDString = "";
          // }
        })
        .catch((error) => {
          console.log("Catch on getOPTCCExpData Error: ", error);
        });
    },
    getOPTCCImpData() {
      this.isLoading = true;
      this.branchList = [];
      this.Filter.QFlag = false;
      this.Filter.DFlag = false;
      if (this.Filter.QDFilter) {
        this.Filter.QFlag = false;
        this.Filter.DFlag = true;
      } else if (this.dateRange.startDate && this.Filter.QDFilter == "") {
        this.Filter.QFlag = true;
        this.Filter.DFlag = false;
      }
      let payload = {
        itemCode: "getCCImpOperationalDashboardData",
        Filter: this.Filter,
      };

      DashboardService.getAllOptDashboard(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          this.isLoading = false;

          if (data.getCCImpOOCDMainAllModuleIDList.length > 0) {
            this.getCCImpOOCDMainAllModuleIDList = data.getCCImpOOCDMainAllModuleIDList;
            this.getCCImpOOCDMainAllModuleIDString =
              data.getCCImpOOCDMainAllModuleIDString;
          } else {
            this.getCCImpOOCDMainAllModuleIDList = [];
            this.getCCImpOOCDMainAllModuleIDString = "";
          }
        })
        .catch((error) => {
          console.log("Catch on getOPTCCImpData Error: ", error);
        });
    },

    getOPTTPTExpData() {
      this.isLoading = true;
      this.branchList = [];
      this.Filter.QFlag = false;
      this.Filter.DFlag = false;
      if (this.Filter.QDFilter) {
        this.Filter.QFlag = false;
        this.Filter.DFlag = true;
      } else if (this.dateRange.startDate && this.Filter.QDFilter == "") {
        this.Filter.QFlag = true;
        this.Filter.DFlag = false;
      }
      let payload = {
        itemCode: "getTPTExpOperationalDashboardData",
        Filter: this.Filter,
      };

      DashboardService.getAllOptDashboard(payload)
        .then((response) => {
          const { data, status, statusText } = response;

          if (data.getTPTExpMainList.length > 0) {
            this.getTPTExpMainList = data.getTPTExpMainList;
            this.getTPTExpMainAllModuleIDString = data.getTPTExpMainAllModuleIDString;
          } else {
            this.getTPTExpMainList = [];
            this.getTPTExpMainAllModuleIDString = "";
          }

          if (data.UserData.length > 0) {
            if (data.UserData[0].designation == "Admin") {
            } else {
              this.Filter.branchfilter = data.UserData[0].baseLocation;
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getOPTTPTExpData Error: ", error);
        });
    },
    getOPTTPTImpData() {
      this.isLoading = true;
      this.branchList = [];
      this.Filter.QFlag = false;
      this.Filter.DFlag = false;
      if (this.Filter.QDFilter) {
        this.Filter.QFlag = false;
        this.Filter.DFlag = true;
      } else if (this.dateRange.startDate && this.Filter.QDFilter == "") {
        this.Filter.QFlag = true;
        this.Filter.DFlag = false;
      }
      let payload = {
        itemCode: "getTPTImpOperationalDashboardData",
        Filter: this.Filter,
      };

      DashboardService.getAllOptDashboard(payload)
        .then((response) => {
          const { data, status, statusText } = response;

          if (data.getTPTImpMainList.length > 0) {
            this.getTPTImpMainList = data.getTPTImpMainList;
            this.getTPTImpMainAllModuleIDString = data.getTPTImpMainAllModuleIDString;
          } else {
            this.getTPTImpMainList = [];
            this.getTPTImpMainAllModuleIDString = "";
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getOPTTPTImpData Error: ", error);
        });
    },
    getPDF() {
      var HTML_Width = $("#OperationalDashboardpdf").width();
      var HTML_Height = $("#OperationalDashboardpdf").height();

      var top_left_margin = 15;
      var PDF_Width = HTML_Width + top_left_margin * 2;
      var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
      var canvas_image_width = HTML_Width;
      var canvas_image_height = HTML_Height;

      var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

      html2canvas($("#OperationalDashboardpdf")[0], { allowTaint: true }).then(function (
        canvas
      ) {
        canvas.getContext("2d");

        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF("p", "pt", [PDF_Width, PDF_Height]);
        pdf.addImage(
          imgData,
          "JPG",
          top_left_margin,
          top_left_margin,
          canvas_image_width,
          canvas_image_height
        );

        for (var i = 1; i <= totalPDFPages; i++) {
          pdf.addPage(PDF_Width, PDF_Height);
          pdf.addImage(
            imgData,
            "JPG",
            top_left_margin,
            -(PDF_Height * i) + top_left_margin * 4,
            canvas_image_width,
            canvas_image_height
          );
        }

        pdf.save("Growth_Dashboard_Document" + new Date() + ".pdf");
      });
    },
  },
};
</script>
<style scoped>
.formCard {
  border: none !important;
  padding: 0px;
}
.modal fade show d-block {
  background: none;
}
</style>



// WEBPACK FOOTER //
// optDashboard.vue?18821d04